import InfoTooltip from "components/Popup/InfoTooltip";
import { IHtzEntry } from "Dashboard/scenes/Carnets/domain/IHtzEntry";
import { FormatDateShort } from "utils/dateUtils";

interface IProps {
  htzEntry: IHtzEntry;
  index: number;
}

const HtzRow = ({ htzEntry, index }: IProps) => {
  return (
    <div className="row">
      <div className="col center">
        <div className="bg-item">
          {htzEntry.employee.name}
        </div>
      </div>
      <div className="col center">
        <div className="bg-item center strong">
          {FormatDateShort(htzEntry.date)}
        </div>
      </div>
      <div className="col center">
        <div className="bg-item">
          {htzEntry.itemName}
        </div>
      </div>
      <div className="col left">
        <div className="bg-item bg-item-border-light overflowMinWidth">
          <InfoTooltip classesProp="bg-text-overflow note"
            tooltip={htzEntry.note}>
            {htzEntry.note}
          </InfoTooltip>
        </div>
      </div>
    </div>
  );
};

export default HtzRow;
